import { createContext, useMemo } from 'react';
import DragPreviewManager from './DragPreviewManager';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultDragPreviewPosition = {
  elementLeft: 0,
  elementTop: 0,
  elementWidth: 0,
  elementHeight: 0
};
export const DragPreviewContext = /*#__PURE__*/createContext({
  dragPreviewManager: null
});
export const DragPreviewProvider = ({
  children,
  dragPreviewZIndex
}) => {
  const dragPreviewManager = useMemo(() => {
    return DragPreviewManager.initialize(dragPreviewZIndex, defaultDragPreviewPosition);
  }, [dragPreviewZIndex]);
  return /*#__PURE__*/_jsx(DragPreviewContext.Provider, {
    value: {
      dragPreviewManager
    },
    children: children
  });
};